import AnvisaSolicita from "@/API/backoffice/AnvisaSolicita.js"

export default {
	methods: {
		/**
		 * Action change AnvisaSolicita status
		 * @param data { Object }
		 * @returns {Promise<boolean>}
		 */
		async changeStatus(data) {
			console.debug("AnvisaSolicitaContextMenu@changeStatus: Sending data.")

			this.loading()
			const [err, res] = await AnvisaSolicita.changeStatus(data)
			this.loaded()

			if (err) {
				console.error("AnvisaSolicitaContextMenu@changeStatus: Error sending data.", { err })
				return this.$alertError(this.handleRequestError(err))
			}

			console.info("AnvisaSolicitaContextMenu@changeStatus: Data send.")

			return true
		}
	}
}